import { FC, useCallback, useState } from 'react'
import { MAP_DEFAULT_ZOOM } from '../../core/application/constants'
import { useConfigurationContext } from '../../core/application/contexts'
import { MapContext, Position } from '../../core/application/contexts/MapContext'
import { Location } from '../../core/domain/models/Location'

interface IMapRequestManagerProps {
  children?: React.ReactNode
}

const MapManager: FC<IMapRequestManagerProps> = (props) => {
  const { children } = props
  const { tenantConfiguration } = useConfigurationContext()
  const [panToLocation, setPanToLocation] = useState<Location | null>(null)
  const [zoom, setZoom] = useState(MAP_DEFAULT_ZOOM)

  const [position, setPosition] = useState<Position>({
    // need to get from tenant and stuff
    lng: tenantConfiguration?.initialCoordinate?.longitude || 55.296249,
    lat: tenantConfiguration?.initialCoordinate?.latitude || 25.276987
  })

  const panTo = useCallback((location: Location | null) => {
    setPanToLocation(location)
  }, [])

  const recordPosition = useCallback((pos: Position) => {
    setPosition(pos)
  }, [])

  return (
    <MapContext.Provider value={{ panTo, panToLocation, setZoom, zoom, position, recordPosition }}>
      {children}
    </MapContext.Provider>
  )
}

export default MapManager
